import CreateUserForm from './CreateUserForm'
import { actions, connect, selectors } from '../../../stores'

const mapStateToProps = state => ({
  createRetailer: selectors.auth.selectCreateRetailer(state),
  isLoading: selectors.auth.selectIsLoading(state),
  isCreateAccountFulfilled: selectors.auth.selectIsCreateAccountFulfilled(state),
  establishmentName: selectors.auth.selectEstablishmentName(state),
  emailError: selectors.auth.selectEmailError(state),
  phoneError : selectors.auth.selectPhoneError(state),
  errorMessage: selectors.auth.selectErrorMessage(state)
})

const mapDispatchToProps = dispatch => ({
  createAccount: payload => dispatch(actions.auth.createAccount(payload)),
  resetState: payload => dispatch(actions.auth.resetState(payload))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateUserForm)
